<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UvZl51/tc-custom/9781685504267.jpg?1723405445835" alt="This image is the cover for the book In Tune"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In Tune
      </h1>
      <p class="bookDescription body article font2">
        <p>In college, Paxton Barrilla and Mars Hudson built a strong foundation for lifelong friendship. Then their careers take them to opposite sides of the country. When they walk into a recording studio in Las Vegas, Pax as producer and Mars as clarinet player, they haven’t seen each other for almost twenty years.<br/><br/>At first, Pax’s plans are simply to make the best jazz record he possibly can. Mars? He wants that, too. But what he wants more is a chance to see if long-ago friendship and a gift for working together might add up to more.<br/><br/>The overture is a surprise, but Pax is interested. After three weeks of the kinds of conversations they never had with anyone else, are they ready to see if they’ve struck the right chord?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexandra Caluen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3621d54b